// action types
export const SET_HRRR_VALUE = 'SET_HRRR_VALUE';
export const SET_HREF_VALUE = 'SET_HREF_VALUE';
//export const CLEAR_HRRR_VALUE = 'CLEAR_HRRR_VALUE';
//export const CLEAR_HREF_VALUE = 'CLEAR_HREF_VALUE';

// action creators
export const setHrrrValue = (value) => ({
  type: SET_HRRR_VALUE,
  value
});

export const setHrefValue = (value) => ({
    type: SET_HREF_VALUE,
    value
  });

// initial state
const initialState = {
  hrrrRunTimeValue: '',
  hrefRunTimeValue:''
};

// reducer
export default (state = initialState, { type, value}) => {
  switch (type) {
    case SET_HRRR_VALUE:
      return {
        ...state,
        hrrrRunTimeValue: value
      };

    case SET_HREF_VALUE:
      return {
        ...state,
        hrefRunTimeValue: value
      };
    /* case CLEAR_HRRR_VALUE:
      return {
        ...state,
        hrrrRunTimeValue: ""
      };
    case CLEAR_HREF_VALUE:
      return {
        ...state,
        hrefRunTimeValue: ""
      }; */
    default:
      return state;
  }
}
